export const SESSION_EXPIRED_EVENT = 'dataunfold:session-expired';
export const SESSION_EXPIRED_LOGIN_URL = '/login?reason=session_expired';
export const SIGNED_OUT_LOGIN_URL = '/login?reason=signed_out';

export const isInvalidSessionError = (error) => (
  Number(error?.status) === 401
  && String(error?.code || '').trim() === 'invalid_session'
);
